import { useEffect, useState } from "react";

import { getLots } from "services/sosInventoryService/sosApi";

/**
 * @name    useItemLots
 *
 * @summary returns an array of lots, optionally filtered by item, location,
 *          and bin
 *
 * @param   itemId (number)
 *          locationName (string) name property of a location reference
 *            object
 *          dateTime (date) date/time at which onhand quantities should be
 *            calculated
 *          lotTracking (boolean) is lot tracking enabled for this item?
 *          binId (number, optional)
 *
 * @returns array of lots; while waiting for API response, returns null
 */
export function useItemLots(itemId, lotTracking) {
  const [lots, setLots] = useState(null);

  useEffect(() => {
    async function _getLots(itemId) {
      const lots = await getLots({ itemId });
      setLots(lots);
    }

    if (Boolean(itemId && lotTracking)) {
      setLots(null);
      _getLots(itemId);
    } else {
      setLots([]);
    }
  }, [itemId, lotTracking]);

  return lots;
}
